import React, { useState, useEffect, use } from 'react'
import { Navbar, Nav, Collapse } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Icons from '../../constants/Icons'
import { Link, useNavigate } from 'react-router-dom'
import { FaInstagram, FaFacebook } from 'react-icons/fa'
import { NavLink } from 'react-router-dom'
import './Header.css'
function Header () {
  const [headerMenu, setHeaderMenu] = useState([])
  const [openMenu, setOpenMenu] = useState(false)
  const navigate = useNavigate()
  const handelClickLinksRouter = () => {
    navigate('/')
  }
  useEffect(() => {
    fetch('/PackageJson/HeaderMenu/HeaderMenu.json')
      .then(response => response.json())
      .then(data => {
        setHeaderMenu(data)
        console.log('res', data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])
  const sortedServices = headerMenu.sort(
    (b, a) => b.displayOrder - a.displayOrder
  )

  return (
    <Navbar
      expand='lg'
      className='navbar-light '
      style={{
        borderBottom: 'none',
        position: 'relative',
        top: '0px',
        width: '100%',
        padding: '0px',
        backgroundColor: ' #091c44'
      }}
    >
      <Navbar.Brand
        style={{ cursor: 'pointer', padding: '0px' }}
        className=' logo-header'
        to='/'
      >
        <img
          onClick={handelClickLinksRouter}
          src={Icons.logo}
          alt='Logo'
          className='d-inline-block align-top'
          style={{ width: '100px' }}
        />
      </Navbar.Brand>
      <div
        className={`header-menu ${
          openMenu ? 'header-menu-block' : 'header-menu-none'
        }`}
      >
        {sortedServices.map((item, index) => (
          <div
            style={{
              color: 'white',
              marginLeft: '10px',
              marginBottom: '-22px'
            }}
            key={index}
          >
            <NavLink
              to={item.router}
              className={({ isActive }) =>
                isActive ? 'headerMenu active' : 'headerMenu'
              }
              onClick={() => setOpenMenu(false)}
            >
              <img src={item.Icons} width='20' height='20' alt={item.name} />
              <div style={{ color: '#f8ac19' }}>{item.name}</div>
            </NavLink>
          </div>
        ))}
      </div>
      <div className='social-links'>
        <Link
          to='https://www.instagram.com/arrshiyana_tours_and_travels'
          target='_blank'
        >
          <FaInstagram />
        </Link>
        <Link
          to='https://www.facebook.com/people/Arrshiyana-Tours-Travels/61571813285851/'
          target='_blank'
        >
          <FaFacebook />
        </Link>
      </div>

      <div className='threeLine' onClick={() => setOpenMenu(!openMenu)}>
        <img src={Icons.Menu} alr='' />
      </div>
      {openMenu && (
        <div
          onClick={() => setOpenMenu(false)}
          className='GuestCounter-center'
          style={{ zIndex: '99999999' }}
        ></div>
      )}
    </Navbar>
  )
}

export default Header
